var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAplicacoesMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aplicacoes-mobile",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aplicacoes-mobile_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,33.1H59.3c-6.8,0-12.3,5.5-12.3,12.3v80.1c0,6.8,5.5,12.3,12.3,12.3h52.3c6.8,0,12.3-5.5,12.3-12.3 V45.3C123.9,38.6,118.4,33.1,111.7,33.1z M115.8,125.6c0,2.3-1.8,4.1-4.1,4.1H59.3c-2.3,0-4.1-1.8-4.1-4.1V45.3 c0-2.3,1.8-4.1,4.1-4.1h52.3c2.3,0,4.1,1.8,4.1,4.1v80.2H115.8z M89.6,117.3c0,2.3-1.8,4.1-4.1,4.1s-4.1-1.8-4.1-4.1 c0-2.3,1.8-4.1,4.1-4.1S89.6,115.1,89.6,117.3z M81.9,54.5v8.2c-2.3,0-4.1,1.8-4.1,4.1v2c0,3.1-1.2,6-3.1,8.2 c1.9,2.2,3.1,5,3.1,8.2v2c0,2.3,1.8,4.1,4.1,4.1v8.2c-6.8,0-12.3-5.5-12.3-12.3v-2c0-2.3-1.8-4.1-4.1-4.1v-8.2 c2.3,0,4.1-1.8,4.1-4.1v-2C69.6,60,75.1,54.5,81.9,54.5z M105.5,73v8.2c-2.3,0-4.1,1.8-4.1,4.1v2c0,6.8-5.5,12.3-12.3,12.3v-8.2 c2.3,0,4.1-1.8,4.1-4.1v-2c0-3.1,1.2-6,3.1-8.2c-1.9-2.2-3.1-5-3.1-8.2v-2c0-2.3-1.8-4.1-4.1-4.1v-8.2c6.8,0,12.3,5.5,12.3,12.3v2 C101.4,71.1,103.3,73,105.5,73z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicacoesMobile);
export default __webpack_public_path__ + "static/media/aplicacoes-mobile.4b66a1a68a33918e4a366588eebbcc4b.svg";
export { ForwardRef as ReactComponent };